export default __webpack_public_path__ + "static/media/thIcon.acc8d99e.svg";